const lerp = (v0, v1, t) => v0 + t * (v1 - v0)
const colorToStr = color => 'rgba(' + color.r.toFixed(0) + ',' + color.g.toFixed(0) + ',' + color.b.toFixed(0) + ',' + color.a.toFixed(3) + ')'
const colorLerp = (c0, c1, t) => ({
    r: lerp(c0.r, c1.r, t),
    g: lerp(c0.g, c1.g, t),
    b: lerp(c0.b, c1.b, t),
    a: lerp(c0.a, c1.a, t)
})
const lerp3 = (v0, v1, v2, t) =>
{
    if (t < 0.5)
        return lerp(v0, v1, t * 0.5)
    else
        return lerp(v1, v2, t + t - 1)
}
const colorLerp3 = (c0, c1, c2, t) => ({
    r: lerp3(c0.r, c1.r, c2.r, t),
    g: lerp3(c0.g, c1.g, c2.g, t),
    b: lerp3(c0.b, c1.b, c2.b, t),
    a: lerp3(c0.a, c1.a, c2.a, t)
})

const COLOR = {
    WHITE: 'white',
    DARK: 'dark',
    BLUE: 'blue'
}

export {
    lerp,
    colorToStr,
    colorLerp,
    lerp3,
    colorLerp3,
    COLOR
}
